import LoginedRoute from 'pages/LoginedRoute'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import PrivateRouter from './pages/PrivateRouter'
import { defaultRouter, privateRouter, publicRouter, unAuth } from './routes'
import PublicRouter from 'pages/PublicRouter'
import { v4 as uuidv4 } from 'uuid'
import { useEffect } from 'react'
import { DEVICE_UUID } from 'configs/constant'
import DefaultRouter from 'pages/DefaultRouter'
const RouterConfig = () => {
  useEffect(() => {
    const deviceToken = localStorage.getItem(DEVICE_UUID)
    if (!deviceToken) {
      localStorage.setItem(DEVICE_UUID, uuidv4())
    }
  }, [])

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<LoginedRoute />}>
          {unAuth.map((router, key) => {
            return <Route {...router} key={key} />
          })}
        </Route>
        <Route element={<PrivateRouter />}>
          {privateRouter.map((router, key) => {
            const { path, element } = router
            const props = {
              key,
              path,
              element
            }
            return <Route {...props} key={key} element={element} />
          })}
        </Route>
        <Route element={<PublicRouter />}>
          {publicRouter.map((router, key) => {
            return <Route {...router} key={key} />
          })}
        </Route>
        <Route element={<DefaultRouter />}>
          {defaultRouter.map((router, key) => {
            return <Route {...router} key={key} />
          })}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default RouterConfig
